import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { CheckBox } from '../../../../../../components/CheckBox'
import {
  corporateColor,
  lightBackground,
  NECROPSY_STATE,
  white,
} from '../../../../../../theme/colors'
import { Order, StateForm } from '../../../../../../context/Logistics/fuel/types'
import { MoreIcon } from '../../../../../../components/Svg'
import moment from 'moment'

interface Props {
  item: Order
  isCheck: boolean
  hasBg: boolean
  onSelect: (item: Order) => void
  onNavigate: (item: Order) => void
}

const STATUS_LABEL: Record<StateForm, string> = {
  sent: 'Enviado',
  pending: 'No enviado',
  sending: 'Sincronizando',
  'in-progress': 'En progreso',
}

const STATE_COLOR: Record<StateForm, string> = {
  ...NECROPSY_STATE,
  'in-progress': '#F5A623',
}

export const Item = ({ item, isCheck, onSelect, hasBg, onNavigate }: Props) => {
  const stateForm = item.stateForm ?? 'pending'
  const savedDate = item.savedAt ? moment(item.savedAt).format('DD/MM/YYYY HH:mm') : '—'

  return (
    <View style={[style.container, hasBg && { backgroundColor: lightBackground }]}>
      <View style={style.headerRow}>
        <View style={{ flex: 1 }}>
          <CheckBox
            isCheck={isCheck}
            item={{ id: item.orderNumber ?? '', name: item.orderNumber ?? '' }}
            onPress={() => onSelect(item)}
          />
        </View>
        <TouchableOpacity onPress={() => onNavigate(item)}>
          <MoreIcon height={24} width={24} />
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1.5 }}>
          <Text style={[style.stateTitle, { color: STATE_COLOR[stateForm] }]}>
            {STATUS_LABEL[stateForm]}
          </Text>
          <Text style={style.label}>N° {item.orderNumber}</Text>
          <Text style={style.label}>{item.centerName}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={style.label}>{savedDate}</Text>
          {item.supplierName ? <Text style={style.label}>{item.supplierName}</Text> : null}
        </View>
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: { paddingHorizontal: 24, paddingVertical: 16, backgroundColor: white },
  headerRow: { justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' },
  stateTitle: { fontSize: 16, fontWeight: '500' },
  label: { fontSize: 14, fontWeight: '400', color: corporateColor, marginTop: 2 },
})
